var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item-group',{staticClass:"text-center",attrs:{"value":_vm.value,"mandatory":""},on:{"change":_vm.onItemChange}},_vm._l((_vm.length),function(n){return _c('v-item',{key:("btn-" + n),scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-btn',{attrs:{"color":active ? 'primary' : 'grey',"input-value":active,"icon":""},on:{"click":toggle}},[_c('v-icon',[_vm._v("mdi-record")])],1)]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }